import { render, staticRenderFns } from "./PlSalesStatisticGrid.vue?vue&type=template&id=35ddd2c2&scoped=true"
import script from "./PlSalesStatisticGrid.vue?vue&type=script&lang=js"
export * from "./PlSalesStatisticGrid.vue?vue&type=script&lang=js"
import style0 from "./PlSalesStatisticGrid.vue?vue&type=style&index=0&id=35ddd2c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ddd2c2",
  null
  
)

export default component.exports